import { createContext, useContext } from 'react';
import { ApiUrlBuilder } from '../ApiUrlBuilder';

export const ApiUrlBuilderContext = createContext<ApiUrlBuilder>(undefined!);

export function useApiUrlBuilder() {
  return useContext(ApiUrlBuilderContext);
}
